import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from '../pages/home/home.component';
import {ServicesComponent} from '../pages/services/services.component';
import {TeamComponent} from '../pages/team/team.component';
import {ContactComponent} from '../pages/contact/contact.component';
import {WorkListComponent} from '../pages/work-list/work-list.component';
import {WorkDetailComponent} from '../pages/work-detail/work-detail.component';

export const ROUTES: Routes = [
  {
    path: 'services',
    component: ServicesComponent,
    data: {templateSlug: 'services'}
  },
  {
    path: 'team',
    component: TeamComponent,
    data: {templateSlug: 'team'}
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {templateSlug: 'contact'}
  },
  {
    path: 'work',
    component: WorkListComponent,
    data: {templateSlug: 'works'}
  },
  {
    path: 'work/:slug',
    component: WorkDetailComponent,
    data: {templateSlug: 'work'}
  },
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
    data: {templateSlug: 'home'}
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(ROUTES)
  ],
  exports: [RouterModule]
})
export class RoutingModule {
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/routing/routing.module.ts